function getRandom255(){
  const array = new Uint8Array(1);
  window.crypto.getRandomValues(array);
  const random = array[0];
  return random;
}
// 创建一个隐藏文本的函数
export function hideTextInImage(textToHide) {
  return new Promise((resolve, reject) => {    
    try {      
      const canvas = document.createElement("canvas");
      const textBinary = textToHide.split('').map(char => char.charCodeAt(0).toString(2).padStart(8, '0')).join('');
      // 没有 图片 生成10*10的随机图片
      const width = 18;
      const height = 18;
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      for (var i = 0; i < width; i++) {
        for (var j = 0; j < height; j++) {
          var randomColor = 'rgb(' + getRandom255() + ',' + getRandom255() + ',' + getRandom255() + ')';
          ctx.fillStyle = randomColor;
          ctx.fillRect(i, j, 1, 1);
        }
      }
      // 获取图像的像素数据
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imageData.data;
  
      let textIndex = 0;
      // 遍历图像的每个像素
      for (let i = 0; i < pixels.length; i += 4) {
        if (textIndex < textBinary.length) {
          // 将文本的二进制逐位隐藏在像素的最低有效位
          pixels[i] = pixels[i] & ~1 | parseInt(textBinary[textIndex]);
          textIndex++;
        }
      }
      // 将修改后的像素数据放回画布
      ctx.putImageData(imageData, 0, 0);
      resolve(canvas.toDataURL().split(',')[1]);
    } catch (error) {
      reject(error);
    }
  })
}